import { inject } from '@angular/core';
import { CanDeactivateFn } from '@angular/router';
import { StudentsFacade } from '../facades/students.facade';

export function StudentsCleanup<T>(): CanDeactivateFn<T> {
    return () => {
        const studentsFacade = inject(StudentsFacade);
        studentsFacade.clear();

        return true;
    };
}
